import React from 'react';
import { AuthLayout } from '../components/AuthLayout';
import { CheckCircle, ArrowRight } from 'lucide-react';

interface PostSignupPageProps {
  destinationLabel: string;
  onContinue: () => void;
  onSetPassword: () => void;
}

export const PostSignupPage: React.FC<PostSignupPageProps> = ({
  destinationLabel,
  onContinue,
  onSetPassword,
}) => {
  return (
    <AuthLayout title="Account created!" iconGradient="from-green-500 to-blue-600">
      <div className="bg-white rounded-lg shadow-sm p-6 space-y-6">
        <div className="flex justify-center">
          <div className="bg-green-100 p-3 rounded-full">
            <CheckCircle className="h-10 w-10 text-green-600" />
          </div>
        </div>

        <p className="text-center text-gray-600 text-sm">
          Your Roam account is ready. You can set a password now, or continue and do it later from your account settings.
        </p>

        <button
          onClick={onContinue}
          className="group relative w-full flex items-center justify-center py-2.5 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          Continue to {destinationLabel}
          <ArrowRight className="ml-2 h-4 w-4" />
        </button>

        <div className="text-center">
          <button
            onClick={onSetPassword}
            className="text-sm text-gray-500 hover:text-blue-600 underline underline-offset-2"
          >
            Set a password (optional)
          </button>
        </div>
      </div>
    </AuthLayout>
  );
};
